import React from 'react';
import EditButton from '../../../components/ui/EditButton';
import { getPendingMemberDisplayName, sortWaitlistMembers } from '../../../utils/waitlist';

function formatTimestamp(value) {
  const date = typeof value?.toDate === 'function' ? value.toDate() : value instanceof Date ? value : null;
  return date ? date.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' }) : '';
}

export default function WaitlistCard({
  waitlistMembers = [],
  onEdit,
  joinRoutingEnabled = false,
}) {
  const orderedMembers = sortWaitlistMembers(waitlistMembers);
  const waitingCount = orderedMembers.length;
  const waitlistStatusLabel = joinRoutingEnabled ? 'Waitlist active' : 'Waitlist inactive';
  const waitlistCountLabel = `${waitingCount} ${waitingCount === 1 ? 'person' : 'people'} waiting`;

  return (
    <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">Waitlist</span>
        <EditButton section="waitlist" onEdit={onEdit} />
      </div>

      <div className="card-body">
        <div className="text-muted small" style={{ marginBottom: orderedMembers.length > 0 ? '0.75rem' : 0 }}>
          {waitlistStatusLabel} · {waitlistCountLabel}
        </div>
        {orderedMembers.length === 0 ? (
          <p className="text-muted small" style={{ marginBottom: 0 }}>
            {joinRoutingEnabled
              ? 'Approved joiners are added to the waitlist before payment.'
              : 'Approved joiners go straight to payment.'}
          </p>
        ) : (
          <ul className="member-list">
            {orderedMembers.slice(0, 6).map((member, index) => {
              const displayName = getPendingMemberDisplayName(member);
              const targetCount = Array.isArray(member.membershipTargetUserIds) ? member.membershipTargetUserIds.length : 1;
              const joinedWaitlistAt = formatTimestamp(member.waitlistedAt || member.createdAt);
              return (
                <li
                  key={member.id}
                  className="member-list-item clickable"
                  role="button"
                  tabIndex={0}
                  onClick={() => onEdit?.()}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      onEdit?.();
                    }
                  }}
                >
                  <div className="member-row">
                    <strong className="member-name">#{index + 1} {displayName}</strong>
                    <div className="text-muted small member-meta">
                      {targetCount > 1 ? `Family request (${targetCount} members)` : 'Individual request'}
                    </div>
                    {joinedWaitlistAt && (
                      <div className="text-muted small member-meta">
                        Waitlisted {joinedWaitlistAt}
                      </div>
                    )}
                  </div>
                </li>
              );
            })}
            {orderedMembers.length > 6 && (
              <li className="text-muted small">+ {orderedMembers.length - 6} more waitlisted members</li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
}
